<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: dialogWidth, maxWidth: maxWidth }"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [showHeader]="false"
  styleClass="wip-dialog"
  (onHide)="onDialogHide()">

  <div class="wip-shell" [class.wip-shell--document]="variant === 'document'">
    <button
      type="button"
      pButton
      icon="pi pi-times"
      class="wip-close p-button-rounded p-button-text"
      (click)="onCloseClick()"
      aria-label="Chiudi">
    </button>

    <div class="wip-visual" [attr.data-variant]="variant" aria-hidden="true">
      <ng-container *ngIf="variant === 'document'; else defaultVisual">
        <div class="wip-docs">
          <div class="wip-docs__sheet wip-docs__sheet--back"></div>
          <div class="wip-docs__sheet wip-docs__sheet--mid"></div>
          <div class="wip-docs__sheet wip-docs__sheet--front">
            <span class="wip-docs__line"></span>
            <span class="wip-docs__line"></span>
            <span class="wip-docs__line wip-docs__line--short"></span>
            <i [class]="iconClass"></i>
          </div>
          <div class="wip-docs__spark wip-docs__spark--1"></div>
          <div class="wip-docs__spark wip-docs__spark--2"></div>
        </div>
      </ng-container>
      <ng-template #defaultVisual>
        <div class="wip-visual__ring"></div>
        <div class="wip-visual__ring wip-visual__ring--delayed"></div>
        <div class="wip-visual__orb">
          <i [class]="iconClass"></i>
        </div>
      </ng-template>
    </div>

    <div class="wip-badge">
      <span class="wip-badge__dot"></span>
      <span>{{ title }}</span>
    </div>

    <h3 class="wip-title">{{ message }}</h3>
    <p class="wip-subtitle">{{ subtitle }}</p>

    <div class="wip-details" *ngIf="hasDetails">
      <div class="wip-detail" *ngFor="let detail of details">
        <span class="wip-detail__label">{{ detail.label }}</span>
        <span class="wip-detail__value">{{ detail.value }}</span>
      </div>
    </div>

    <button
      pButton
      type="button"
      [label]="ctaLabel"
      class="p-button-success wip-cta"
      (click)="onCloseClick()">
    </button>
  </div>
</p-dialog>
